import { useNavigate } from 'react-router-dom';
import { TALENT } from '../../data/define';
import Url from '../../data/url';

function Intelligences() {
  const navigate = useNavigate();

  const handleIntelligenceSelect = (intelligence) => {
    navigate(Url.HistoryIntelligenceVideos, { state: { intelligence } });
  };

  return (
    <div className="w-full">
      <div className="flex items-center justify-between gap-2 px-[20px] pt-[20px] pb-[15px]">
        <div className="text-[#1C1C1C] font-[700] text-[20px] text-left]">재능별로 보기</div>
      </div>
      <div className="w-full grid grid-cols-4 grid-rows-2 gap-[5px] mb-[50px] px-[20px]">
        <button
          type="button"
          className="flex flex-col items-center justify-center"
          onClick={() => handleIntelligenceSelect(TALENT.RELATIONSHIP)}
        >
          <div
            className="border border-[#EAEAEA] min-w-[71px] h-[71px] rounded-[24px] bg-[#fff] flex justify-center items-center"
            style={{
              border: '1px solid #EAEAEA',
            }}
          >
            <img
              src={TALENT.RELATIONSHIP.icon}
              alt="IcRelationship"
              className="w-[40px] h-[36px]"
            />
          </div>
          <div
            className="font-[400] text-[14px] mt-[8px]"
            style={{
              color: '#363636',
            }}
          >
            {TALENT.RELATIONSHIP.label}
          </div>
        </button>
        <button
          type="button"
          className="flex flex-col items-center justify-center"
          onClick={() => handleIntelligenceSelect(TALENT.LANGUAGE)}
        >
          <div
            className="border border-[#EAEAEA] min-w-[71px] h-[71px] rounded-[24px] bg-[#fff] flex justify-center items-center"
            style={{
              border: '1px solid #EAEAEA',
            }}
          >
            <img src={TALENT.LANGUAGE.icon} alt="IcLanguage" className="w-[40px] h-[36px]" />
          </div>
          <div
            className="font-[400] text-[14px] mt-[8px]"
            style={{
              color: '#363636',
            }}
          >
            {TALENT.LANGUAGE.label}
          </div>
        </button>
        <button
          type="button"
          className="flex flex-col items-center justify-center"
          onClick={() => handleIntelligenceSelect(TALENT.MATH)}
        >
          <div
            className="border border-[#EAEAEA] min-w-[71px] h-[71px] rounded-[24px] bg-[#fff] flex justify-center items-center"
            style={{
              border: '1px solid #EAEAEA',
            }}
          >
            <img src={TALENT.MATH.icon} alt="IcMath" className="w-[40px] h-[36px]" />
          </div>
          <div
            className="font-[400] text-[14px] mt-[8px]"
            style={{
              color: '#363636',
            }}
          >
            {TALENT.MATH.label}
          </div>
        </button>
        <button
          type="button"
          className="flex flex-col items-center justify-center"
          onClick={() => handleIntelligenceSelect(TALENT.PHYSICAL)}
        >
          <div
            className="border border-[#EAEAEA] min-w-[71px] h-[71px] rounded-[24px] bg-[#fff] flex justify-center items-center"
            style={{
              border: '1px solid #EAEAEA',
            }}
          >
            <img src={TALENT.PHYSICAL.icon} alt="IcPhysics" className="w-[40px] h-[36px]" />
          </div>
          <div
            className="font-[400] text-[14px] mt-[8px]"
            style={{
              color: '#363636',
            }}
          >
            {TALENT.PHYSICAL.label}
          </div>
        </button>
        <button
          type="button"
          className="flex flex-col items-center justify-center"
          onClick={() => handleIntelligenceSelect(TALENT.REFLECTION)}
        >
          <div
            className="border border-[#EAEAEA] min-w-[71px] h-[71px] rounded-[24px] bg-[#fff] flex justify-center items-center"
            style={{
              border: '1px solid #EAEAEA',
            }}
          >
            <img src={TALENT.REFLECTION.icon} alt="IcReflection" className="w-[40px] h-[36px]" />
          </div>
          <div
            className="font-[400] text-[14px] mt-[8px]"
            style={{
              color: '#363636',
            }}
          >
            {TALENT.REFLECTION.label}
          </div>
        </button>
        <button
          type="button"
          className="flex flex-col items-center justify-center"
          onClick={() => handleIntelligenceSelect(TALENT.NATURE)}
        >
          <div
            className="border border-[#EAEAEA] min-w-[71px] h-[71px] rounded-[24px] bg-[#fff] flex justify-center items-center"
            style={{
              border: '1px solid #EAEAEA',
            }}
          >
            <img src={TALENT.NATURE.icon} alt="IcNature" className="w-[40px] h-[36px]" />
          </div>
          <div
            className="font-[400] text-[14px] mt-[8px]"
            style={{
              color: '#363636',
            }}
          >
            {TALENT.NATURE.label}
          </div>
        </button>
        <button
          type="button"
          className="flex flex-col items-center justify-center"
          onClick={() => handleIntelligenceSelect(TALENT.SPACE)}
        >
          <div
            className="border border-[#EAEAEA] min-w-[71px] h-[71px] rounded-[24px] bg-[#fff] flex justify-center items-center"
            style={{
              border: '1px solid #EAEAEA',
            }}
          >
            <img src={TALENT.SPACE.icon} alt="IcSpace" className="w-[40px] h-[36px]" />
          </div>
          <div
            className="font-[400] text-[14px] mt-[8px]"
            style={{
              color: '#363636',
            }}
          >
            {TALENT.SPACE.label}
          </div>
        </button>
        <button
          type="button"
          className="flex flex-col items-center justify-center"
          onClick={() => handleIntelligenceSelect(TALENT.MUSIC)}
        >
          <div
            className="border border-[#EAEAEA] min-w-[71px] h-[71px] rounded-[24px] bg-[#fff] flex justify-center items-center"
            style={{
              border: '1px solid #EAEAEA',
            }}
          >
            <img src={TALENT.MUSIC.icon} alt="IcMusic" className="w-[40px] h-[36px]" />
          </div>
          <div
            className="font-[400] text-[14px] mt-[8px]"
            style={{
              color: '#363636',
            }}
          >
            {TALENT.MUSIC.label}
          </div>
        </button>
      </div>
    </div>
  );
}

export default Intelligences;
